module.exports = __webpack_public_path__ + "img/btdx.a8988aa0.svg";